module.exports = __webpack_public_path__ + "media/images/icons/icon_twitter-75f8bb1d5b6ba3712e9629901005809e.png";